<template>
  <div
    :class="theme == 1 ? 'white' : 'black'"
    style="height: 100%; width: 100%; position: absolute"
  >
    <div class="sub-tab">
      <van-tabs
        v-model="active"
        line-width="24px"
        line-height="2px"
        @click="tabClick"
        :border="false"
        sticky
        title-active-color="#F44336"
      >
        <van-tab title="使用中">
          <van-pull-refresh
            v-model="refreshing"
            @refresh="onRefresh"
            success-text="刷新成功"
          >
            <div class="sub-list">
              <van-list
                v-if="list.length > 0"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
              >
                <div
                  class="sub-item"
                  v-for="(item, index) in list"
                  :key="index"
                  @click="goInfo(item)"
                >
                  <div style="width: 100%; height: 1px"></div>
                  <div class="item-left">
                    <van-image
                      :src="picHost + item.thumbnailUrl"
                      width="48"
                      height="48"
                      round
                    />
                  </div>
                  <div class="item-right">
                    <span class="item-name van-ellipsis">{{ item.title }}</span>
                    <span
                      class="item-expdate van-ellipsis"
                      v-if="
                        item.type != 2 ||
                        (item.type == 2 && item.relatedId != 1)
                      "
                      >{{ item.endDate }}到期</span
                    >
                  </div>
                  <!-- <div class="item-btn" @click.stop="renewal(item)">续费</div> -->
                  <van-divider
                    style="
                      margin: 0;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      right: 0;
                    "
                  />
                </div>
              </van-list>
              <div class="nosubdata" v-else-if="list.length == 0" v-show="show">
                <img v-if="theme == 2" src="../assets/nodata@2x1.png" />
                <img v-else src="../assets/nodata@2x2.png" />
                <span>暂未开通服务</span>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
        <van-tab title="已到期">
          <van-pull-refresh
            v-model="refreshing"
            @refresh="onRefresh"
            success-text="刷新成功"
          >
            <div class="sub-list">
              <van-list
                v-if="dqlist.length > 0"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad"
              >
                <div
                  class="sub-item"
                  v-for="(item, index) in dqlist"
                  :key="index"
                  @click="goInfo(item)"
                >
                  <div style="width: 100%; height: 1px"></div>
                  <div class="item-left">
                    <van-image
                      :src="picHost + item.thumbnailUrl"
                      width="48"
                      height="48"
                      round
                    />
                  </div>
                  <div class="item-right">
                    <span class="item-name van-ellipsis">{{ item.title }}</span>
                    <span
                      class="item-expdate van-ellipsis"
                      v-if="
                        item.type != 2 ||
                        (item.type == 2 && item.relatedId != 1)
                      "
                      >{{ item.endDate }}到期</span
                    >
                  </div>
                  <!-- <div class="item-btn" @click.stop="renewal(item)">开通</div> -->
                  <van-divider
                    style="
                      margin: 0;
                      position: absolute;
                      bottom: 0;
                      left: 0;
                      right: 0;
                    "
                  />
                </div>
              </van-list>
              <div
                class="nosubdata"
                v-else-if="dqlist.length == 0"
                v-show="show"
              >
                <img v-if="theme == 2" src="../assets/nodata@2x1.png" />
                <img v-else src="../assets/nodata@2x2.png" />

                <span>暂无到期服务</span>
              </div>
            </div>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
      <!-- <div class="sub-normal" v-bind:class="{active: tabIndex == 0}" @click="tabClick(0)">
        <span>使用中</span>
        <div v-show="tabIndex == 0" class="tab_line"></div>
      </div>
      <div class="sub-expdate" v-bind:class="{active: tabIndex == 1}" @click="tabClick(1)">
        <span>已到期</span>
        <div v-show="tabIndex == 1" class="tab_line"></div>
      </div>
      </div>-->
      <!-- <van-divider style="margin: 0;" /> -->
    </div>
  </div>
</template>
<script>
import { Divider, Toast, Image, List, PullRefresh, Tab, Tabs } from "vant";
import MallServiceApi from "@/api/mall";
import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var picHost = process.env.VUE_APP_PIC_BASE_URL;
export default {
  components: {
    [Divider.name]: Divider,
    [Toast.name]: Toast,
    [Image.name]: Image,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
  },

  data() {
    return {
      tabIndex: 0,
      subData: [],
      subExpedData: [],
      list: [],
      dqlist: [],
      picHost: picHost,
      active: 0,
      loading: false,
      finished: false,
      refreshing: false,
      show: false,
      total: "",
      page: 1,
      pageIndex: 1,
      dqtotal: 0,
      theme: 1,
    };
  },
  activated() {
    this.theme = sessionStorage.getItem("theme");
  },
  created() {
    if (sessionStorage.getItem("theme") == 2) {
      this.theme = 2;
    } else {
      this.theme = 1;
    }
    if (sessionStorage.getItem("SubActive")) {
      var active = sessionStorage.getItem("SubActive");
      this.active = parseInt(active);
      // console.log(this.active)
    }

    this.getSubList(this.active);
  },
  mounted() {
    var that = this;
    if (getBrowserUserAgent().android) {
      that.$bridge.registermethod("changeTheme", function (responseData) {
        responseData = JSON.parse(responseData);
        that.theme = responseData;
        sessionStorage.setItem("theme", responseData);
      });
    } else {
      connectWebViewJavascriptBridge(() => {
        var that = this;
        window.WebViewJavascriptBridge.registerHandler(
          "changeTheme",
          function (responseData) {
            responseData = JSON.parse(responseData);
            that.theme = responseData;
            sessionStorage.setItem("theme", responseData);
          }
        );
      });
    }
  },
  methods: {
    tabClick(name) {
      this.page = 1;
      this.pageIndex = 1;
      this.show = false;
      this.list = [];
      this.dqlist = [];
      this.total = 0;
      this.dqtotal = 0;
      this.finished = false;
      this.getSubList(name);
    },
    onLoad() {
      setTimeout(() => {
        this.loading = false;
        if (this.active == 0) {
          this.page++;
          this.getSubList(this.active);

          if (this.list.length >= this.total) {
            this.finished = true;
          }
        } else {
          this.pageIndex++;
          this.getSubList(this.active);

          if (this.dqlist.length >= this.dqtotal) {
            this.finished = true;
          }
        }
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据

      // 重新加载数据
      setTimeout(() => {
        this.finished = false;
        this.list = [];
        this.page = 1;
        this.pageIndex = 1;

        this.dqlist = [];
        this.refreshing = false;

        this.getSubList(this.active);
      }, 1000);
      // 将 loading 设置为 true，表示处于加载状态
    },
    getSubList(id) {
      // Toast.loading({
      //   message: "加载中...",
      //   forbidClick: true,
      //   loadingType: "spinner",
      // });
      if (id == 0) {
        let params = { state: 1, page: this.page, pageSize: 10 };
        MallServiceApi.getSubList(params).then((res) => {
          // Toast.clear();
          // console.log(res);
          if (res.code == 200) {
            this.list = this.list.concat(res.data.records);
            this.total = res.data.total;
            if (res.data.records < 10) {
              this.finished = true;
            }
            if (this.list.length == 0) {
              this.show = true;
            } else {
              this.show = false;
            }
          } else if (res.code == 401) {
            setTimeout(() => {
              this.getSubList(this.active);
            }, 1000);
          }
        });
      } else {
        let params = { state: 2, page: this.pageIndex, pageSize: 10 };
        MallServiceApi.getSubList(params).then((res) => {
          // Toast.clear();
          // console.log(res);
          if (res.code == 200) {
            this.dqlist = this.dqlist.concat(res.data.records);
            this.dqtotal = res.data.total;
            if (res.data.records < 10) {
              this.finished = true;
            }
            if (this.dqlist.length == 0) {
              this.show = true;
            } else {
              this.show = false;
            }
          } else if (res.code == 401) {
            setTimeout(() => {
              this.getSubList(this.active);
            }, 1000);
          }
        });
      }

      // this.subData = this.subData.concat(list);
      // this.subExpedData = this.subExpedData.concat(expList);
    },

    goInfo(item) {
      sessionStorage.setItem("SubActive", this.active);
      this.$router.push({
        path: "/product_info",
        query: { type: item.productCategoryId, id: item.relatedId },
      });
    },

    renewal(item) {
      sessionStorage.setItem("SubActive", this.active);
      this.$router.push({
        path: "/pay",
        query: {
          type: item.productCategoryId,
          id: item.relatedId,
          isRenewal: true,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.white {
  background: #eeeff4;
  color: #333;
  .sub-item {
    background-color: white;
  }
  .item-name {
    color: #333;
  }
  .item-expdate {
    color: #999;
  }
  /deep/.van-tabs__wrap {
    border-bottom: 0.02rem solid #ebedf0;
  }
}
.black {
  color: #f0f1f4;
  background: #000;

  /deep/.van-tabs__nav {
    background-color: #12161f;
  }
  /deep/.van-tab {
    color: #f0f1f4;
  }
  /deep/.van-tabs__wrap {
    border-bottom: 0.02rem solid #242b3b;
  }
  /deep/.van-divider {
    border-color: #242b3b;
  }
  /deep/ .van-list__error-text,
  /deep/ .van-list__finished-text,
  /deep/.van-list__loading,
  /deep/ .van-pull-refresh__head {
    background: #121620;
  }
  .sub-item {
    background: #121620;
  }
  .item-name {
    color: #f0f1f4;
  }
  .item-expdate {
    color: #676d78;
  }
  .nosubdata span {
    color: #475166;
  }
}
.sub-tab {
  width: 100%;
}

.nosubdata {
  text-align: center;
  margin-top: 150px;
}
.nosubdata img {
  height: 111px;margin: 0 auto;
  width: 184px;
}
.nosubdata span {
  display: block;
  font-size: 12px;
  color: #999999;
  margin-bottom: 15px;
}

.sub-list .sub-item {
  height: 70px;
  width: 100%;
  position: relative;
  color: #f0f1f4;
  // background-color: white;
}

.sub-list .sub-item .item-left {
  position: absolute;
  left: 16px;
  top: 10px;
  width: 48px;
  height: 48px;
}

.sub-list .sub-item .item-right {
  margin-left: 72px;
}

.sub-list .sub-item .item-right .item-name {
  width: 150px;
  height: 24px;
  font-size: 17px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: bold;

  line-height: 24px;
  display: block;
  margin-top: 15px;
}

.sub-list .sub-item .item-right .item-expdate {
  width: 97px;
  height: 20px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  // color: rgba(153, 153, 153, 1);
  line-height: 20px;
  display: block;
  /* margin-top: 4px; */
}

.sub-list .sub-item .item-btn {
  display: flex;
  position: absolute;
  top: 22px;
  right: 16px;
  width: 60px;
  height: 24px;
  background: rgba(244, 67, 54, 1);
  border-radius: 2px;
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 20px;
  justify-content: center;
  align-items: center;
}
</style>